import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-float-label margin-0" }
const _hoisted_2 = { for: "activationCode" }
const _hoisted_3 = {
  class: "inputError",
  style: {"color":"red","font-size":"small"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "grayWide" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("connected_accounts.enter_activation_code")), 1),
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_InputText, {
        id: "activationCode",
        type: "text",
        modelValue: _ctx.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
        name: "activationCode"
      }, null, 8, ["modelValue"]),
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("connected_accounts.activation_code")), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.error), 1)
    ]),
    _createElementVNode("a", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showHelp'))),
      class: "where",
      onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('showHelp')), ["enter"])),
      tabindex: "0"
    }, _toDisplayString(_ctx.$t("connected_accounts.where_to_find")), 33),
    _hoisted_4,
    _createVNode(_component_Button, {
      "event-name": "connectPaymentProviderButton",
      "event-from": "/user/related-accounts/add",
      label: _ctx.$t(`connected_accounts.continue`),
      class: "defaultButton",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendCode())),
      icon: "pi pi-arrow-right",
      iconPos: "right"
    }, null, 8, ["label"]),
    _createElementVNode("a", {
      href: "#",
      style: {"color":"#0ea44d"},
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('previous'))),
      class: "block cancel mt-4",
      tabindex: "0",
      onKeypress: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.$emit('previous')), ["enter"]))
    }, _toDisplayString(_ctx.$t("global.back")), 33),
    _createVNode(_component_router_link, {
      to: { name: 'RelatedAccounts' },
      class: "cancel mt-3"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
      ]),
      _: 1
    })
  ], 64))
}